<template>
    <div class="accordion">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { ref, provide } from "vue";

const props = withDefaults(
    defineProps<{
        multiple?: boolean;
    }>(),
    {
        multiple: true,
    },
);

const openTabs = ref<number[]>([]);

function toggleTab(index: number) {
    if (props.multiple) {
        if (openTabs.value.includes(index)) {
            openTabs.value = openTabs.value.filter((i) => i !== index);
        } else {
            openTabs.value.push(index);
        }
    } else {
        openTabs.value = openTabs.value.includes(index) ? [] : [index];
    }
}

function setTabOpen(index: number, open: boolean) {
    if (openTabs.value.includes(index) && !open) {
        openTabs.value = openTabs.value.filter((i) => i !== index);
    } else if (!openTabs.value.includes(index) && open) {
        openTabs.value.push(index);
    }
}

function setTabClosed(index: number) {
    openTabs.value = openTabs.value.filter((i) => i !== index);
}

provide("toggleTab", toggleTab);
provide("openTabs", openTabs);
provide("multiple", props.multiple);
provide("setTabOpen", setTabOpen);
provide("setTabClosed", setTabClosed);
</script>
